import http from '@/utils/http';
import i18n from '@/main';
import { saveAs } from 'file-saver';

const baseUrl = '/processamento-arquivo';

export default {
    cadastrarSolicitacao(tipoArquivo, data) {
        return http.post({
            url: `${baseUrl}/cadastrar-solicitacao/${tipoArquivo}`,
            data,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.cadastrandoSolicitacaoArquivoFilaProcessamento')
        });
    },

    /**
     * Faz download do arquivo processado usando o nome do arquivo (mais seguro)
     * @param {string} nomeArquivo - Nome do arquivo gerado
     */
    async downloadArquivo(nomeArquivo) {
        try {
            const response = await http.get({
                url: `${baseUrl}/download/${encodeURIComponent(nomeArquivo)}`,
                responseType: 'blob' // Importante para receber arquivo binário
            });

            // Extrair nome do arquivo do header Content-Disposition
            let filename = 'relatorio.xlsx'; // Nome padrão

            const contentDisposition = response.headers['content-disposition'];
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1].replace(/['"]/g, '');
                    // Decodificar UTF-8
                    filename = decodeURIComponent(filename);
                }
            }

            // Usar FileSaver para iniciar download
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            saveAs(blob, filename);

            return { success: true, filename };

        } catch (error) {
            throw error;
        }
    }
};
